import { render, staticRenderFns } from "./TrialReviewAndSign.vue?vue&type=template&id=a472c6ac&"
import script from "./TrialReviewAndSign.vue?vue&type=script&lang=js&"
export * from "./TrialReviewAndSign.vue?vue&type=script&lang=js&"
import style0 from "./TrialReviewAndSign.vue?vue&type=style&index=0&id=a472c6ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports